import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { TeamSettings } from "@/features/settings/components/team-settings"
import { teamListFilters } from "@/features/settings/team-list-filters"
import { organisationTeamQueries } from "@/queries/organisation-team"

const searchSchema = z.object({
  q: z.string().optional(),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/team/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(
      organisationTeamQueries.list(teamListFilters(deps.q ?? ""))
    ),
  component: TeamSettingsPage,
})

function TeamSettingsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <TeamSettings
      query={search.q ?? ""}
      onQueryChange={(query) => {
        void navigate({
          search: query ? { q: query } : {},
          replace: true,
        })
      }}
    />
  )
}
